const DOCUMENT = 'AGENCY_USERS_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: payload => ({ type: actions.LOAD_REQUEST, payload }),
  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),
  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
};

export default actions;
